import React, { useState, useEffect } from 'react';
import Sidebar from '../../components/Navigation/Sidebar';
import Topbar from '../../components/Navigation/Topbar';
import Grid from '../../components/Grid';
import { connect } from 'react-redux';
import { Show } from '../../hooks/Show';
import UpsertCompany from '../../components/Modal/Company/upsertCompany';

const Company = ({
  reduxGetCompanies,
  companies,
  reduxGetCompany,
  reduxDeleteCompany,
}) => {

  const [currentPage, setCurrentPage] = useState(1);
  const [offset, setOffset] = useState(10);
  const [showModal, setShowModal] = useState(false);

  const [search, setSearch] = useState('');
  
  useEffect(() => {
    reduxGetCompanies({
      page: 1,
      offset: offset,
      search: '',
    });
  }, []);

  useEffect(() => {
    reduxGetCompanies({
      page: currentPage,
      offset: offset,
      search: search,
    });
  }, [currentPage]);

  const handleCloseModal = () => {
    setShowModal(false);
    reduxGetCompanies({
      page: 1,
      offset: offset,
      search: search,
    });
  };

  const handleOpenModal = (row) => {
    if (row)
      reduxGetCompany({
        id: row.idCompany,
      });
    setShowModal(true);
  };

  const handleActive = (row) => {
    if (!row.isActive) {
      reduxDeleteCompany(row);
    }
  };

  const handleDelete = (row) => {
    reduxDeleteCompany(row);
  };

  const columns = [
    {
      title: '#',
      render: (rowData) => {
        return <span>{rowData.idCompany}</span>;
      },
      field: 'idCompany',
      searchable: true,
    },
    {
      title: 'Descripción',
      render: (rowData) => {
        return <span>{rowData.description}</span>;
      },
      field: 'description',
      searchable: true,
    },
    {
      title: 'Dirección',
      render: (rowData) => {
        return <span>{rowData.address}</span>;
      },
      field: 'address',
      searchable: true,
    },
    {
      title: 'Opciones',
      render: (rowData) => {
        return (
          <>
            {rowData.isActive ? (
              <>
                <Show when="feature:edit-company">
                  <button
                    title="Editar"
                    className="btn btn-primary btn-sm  btn-circle mr-2"
                    type="button"
                    onClick={(e) => handleOpenModal(rowData)}
                  >
                    <i className="fas fa-edit fa-xs"></i>
                  </button>
                </Show>
                <Show when="feature:disabled-company">
                  <button
                    title="Desactivar"
                    className="btn btn-danger btn-sm btn-circle"
                    type="button"
                    onClick={(e) => handleDelete(rowData)}
                  >
                    <i className="fas fa-times-circle fa-xs"></i>
                  </button>
                </Show>
              </>
            ) : (
              <Show when="feature:enabled-company">
                <button
                  title="Activar"
                  className="btn btn-primary btn-sm  btn-circle mr-2"
                  type="button"
                  onClick={(e) => handleActive(rowData)}
                >
                  <i className="fas fa-check-circle fa-xs"></i>
                </button>
              </Show>
            )}
          </>
        );
      },
    },
  ];

  return (
    <div>
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Topbar />
            <div className="container-fluid">
              <div className="d-sm-flex align-items-center mb-1">
                <h1 className="h3 mb-0 text-gray-800 mr-3">Empresas</h1>
                <Show when="feature:create-company">
                  <button
                    className="btn btn-primary btn-circle"
                    type="button"
                    onClick={(e) => handleOpenModal()}
                  >
                    <i className="fas fa-plus fa-sm"></i>
                  </button>
                </Show>
              </div>
              <p className="mb-4">Módulo de Administración de empresas</p>
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">Listado de Empresas</h6>
                </div>
                <div className="card-body">
                  <Grid
                    cols={columns}
                    data={companies && Object.keys(companies).length > 0 ? companies.items : []}
                    page={
                      companies && Object.keys(companies).length > 0
                        ? Number(companies.page)
                        : currentPage
                    }
                    pages={
                      companies && Object.keys(companies).length > 0
                        ? Number(companies.totalPages)
                        : 0
                    }
                    total={companies && companies.hasOwnProperty('total') ? companies.total : 0}
                    offset={offset}
                    onChangePage={(page) => setCurrentPage(page)}
                    onChangeRange={(value) => {
                      setOffset(value);
                      reduxGetCompanies({
                        page: 1,
                        offset: value,
                        search: search,
                      });
                    }}
                    defaultValue={search}
                    onChangeSearch={(value) => {
                      setSearch(value);
                      reduxGetCompanies({
                        page: 1,
                        offset: offset,
                        search: value,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <UpsertCompany show={showModal} handleClose={handleCloseModal} />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    companies: state.companyState.companies,
    rowDeleted: state.companyState.rowDeleted,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reduxGetCompanies: (payload) =>
      dispatch({
        type: 'FETCH_COMPANIES_REQUEST',
        value: payload,
      }),
    reduxGetCompany: (payload) =>
      dispatch({
        type: 'READ_COMPANY_REQUEST',
        value: payload,
      }),
    reduxDeleteCompany: (payload) =>
      dispatch({
        type: 'DELETE_COMPANY_REQUEST',
        value: payload,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Company);
